module.exports = __webpack_public_path__ + "static/img/ground1a.815b4804.png";